import React from 'react';
import { usePageBanners } from '../../../hooks/usePageBanners';
import PageBanner from '../PageBanner/PageBanner';
import './PricingHero.css';

const SECTION = 'Pricing';

const PricingHero = () => {
  const { hasDynamicBanner, banners } = usePageBanners(SECTION);

  return (
    <section className="pricing-hero">
      {hasDynamicBanner && <PageBanner banners={banners} />}
      {!hasDynamicBanner && (
        <div className="pricing-hero-title-section pricing-hero-title-section--standalone">
          <div className="container">
            <div className="pricing-hero-content">
              <h1 className="pricing-title">
                Pricing
              </h1>
              <p className="pricing-subtitle">
                Choose the plan that suits your requirements.
              </p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default PricingHero;
